export default __webpack_public_path__ + "static/media/insurance.0e13e53a.png";